<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare class='m-b-45' content='1､统一管理商家的总库产品，可用于各个业务版块的关联调用
        2.未上架的产品放入回收站后，业务版块将不能再进行调用，
        ' />
      <div class='mb25 s_flex_ali'>
        <span class='mr15'>
          <a-button type="primary" v-has:createProduct="()=> {$router.push('/product/libs/management/createProduct')}">
            <PlusOutlined />
            添加产品
          </a-button>
        </span>
        <span class='mr15'>
           <!-- @click="()=> {$router.push('/customer/dealer/level_add?type=add')}" -->
          <!-- <a-button type="primary">
            <PlusOutlined />
            批量导入产品
          </a-button> -->
        </span>
        <span class='mr15'>
           <!-- @click="()=> {$router.push('/customer/dealer/level_add?type=add')}" -->
          <!-- <a-button type="link">
            批量导入记录
          </a-button> -->
        </span>
      </div>
      <a-tabs @change="callback" v-model:active="active">
        <a-tab-pane :key="1" tab="产品库">
        </a-tab-pane>
        <a-tab-pane :key="2" tab="回收站">
        </a-tab-pane>
      </a-tabs>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline' >
        <a-form-item label="产品名称" name='product_name'>
          <a-input v-model:value="search.product_name" style="width:280px" placeholder="请输入关键词进行搜索" />
        </a-form-item>
    <!--   <a-form-item label="产品分类" name='level_id'>
          <a-cascader :options="options" :load-data="loadData" placeholder="请选择产品分类" change-on-select @change="onChange" />
        </a-form-item>
        <a-form-item label="商品编码" name='keywords'>
          <a-input v-model:value="search.keywords" placeholder="请输入商品编码进行搜索" />
        </a-form-item>-->
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click='reset'>重置</a-button>
        </a-form-item>
        <a-form-item>
          <a-button class="mr15" type="primary" @click="() => exportAgent('add')"> 导入商品 </a-button>
          <a-button type="primary" ghost @click="exportProduct">导出</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
         
        <template v-slot:product_name="{record}">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+'/'+(record.product_image||record.cover_image_url)" alt=""
                style="width:50px;height: 50px;object-fit:cover">
            </template>
            <template #description>{{record.product_name}}</template>
          </a-card-meta>
        </template>
        <template v-slot:action="{ record }">
          <a-dropdown>
            <a class="ant-dropdown-link"> 操作
              <DownOutlined />
            </a>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item >
                  <!-- type:look详情2修改 -->
                  <a v-has:productDetail="()=>{$router.push({path:'/product/libs/management/productDetail',query:{id:record.id,type:'look'}})}" href="javascript:;">详情</a>
                </a-menu-item>
                <a-menu-item  >
                  <a v-has:editProduct="()=>{$router.push({path:'/product/libs/management/editProduct',query:{id:record.id,type:'edit'}})}" href="javascript:;">修改</a>
                </a-menu-item>
                <a-menu-item v-if="active!=2">
                  <a v-has:productrecycleBin="()=>recovery(record,'del')" href="javascript:;">移入回收站</a>
                </a-menu-item>
                <a-menu-item v-if='active==2'>
                  <a v-has:productrecycleBin="()=>recovery(record,'re')" href="javascript:;">移出回收站</a>
                </a-menu-item>
                <a-menu-item v-if='(record.goods&&record.goods.is_on_sale == 2) || active==2'>
                  <a v-has:delProduct="()=>del(record)" href="javascript:;">删除</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
    </a-card>
  </a-layout>

    <!-- 下载模板 -->
  <a-modal :keyboard="false" centered title="导入商品" v-model:visible="importVisible" :width="700" :footer="null" destroyOnClose>
    <div>
      <p>1，批量导入无法导入商品图或商品视频，商品导入后需通过“编辑”功能上传对应信息；</p>
      <p class="m-t-10">2，请严格按照导入模板中的文件格式进行导入，否则将导致导入失败；</p>
      <p class="m-t-10">3，一次导入商品不能多于500个；</p>
      <a-card :bordered="false">
        <a-upload-dragger
          v-model:fileList="fileList"
          name="files"
          :multiple="false"
          :action="action"
          :headers="{ Authorization: getToken() }"
          @change="handleChange"
        >
          <p class="ant-upload-drag-icon">
            <inbox-outlined></inbox-outlined>
          </p>
          <p class="ant-upload-text">点击上传或者拖拽上传</p>
        </a-upload-dragger>
        <!-- <p style="color:#f04635">{{uploadStatus}}</p> -->
      </a-card>
      <a-button class="m-t-20" style="transform: translateX(-50%); margin-left: 50%" type="primary" @click="exportTemplate">下载模板</a-button>
    </div>
  </a-modal>
  <!-- 成功结果 -->
  <a-modal :keyboard="false" centered title="操作成功" v-model:visible="importSuccess" :width="500" destroyOnClose @ok="importSuccess = false">
    <p class="m-b-10">1、成功导入{{ importSuccessData.success_num }}条数据</p>
    <p>
      2、导入失败{{ importSuccessData.fail_num }}条数据
      <a class="p-l-15" href="javascript:;" @click="downError" v-if="importSuccessData.fail_num > 0">点击下载导入失败文件</a>
    </p>
  </a-modal>
</template>
<script>
import { PlusOutlined,DownOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { getProduct,getRecoveryList,createProductRecovery ,deleteProduct,managementImport,downloadmanagenmentModel,exportProductList } from "@/api/product";
import { iscode } from "@/utils/app";
  import store from "@/store";
  import { getToken } from "@/libs/util";
// 初始化默认筛选项数值
let defSearch = {
  product_name: "",
  level_id: undefined,
  page: 1,
  limit: 10,
};
export default {
  components: {
    PlusOutlined,
    DownOutlined
  },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
        info: store.state.user.info,
      listLoading: false,
      time: [],
      total: 1,
      active:1,
      fileList: [],
      importSuccessData: {},
      action: managementImport(), //接口
      importSuccess: false,
    });
    let columns = [
     {
        title: "商品编号",
        dataIndex: "product_sn",
        key: "product_sn",
        ellipsis: true,
        width:200
      },
      {
        title: "产品名称",
        dataIndex: "product_name",
        key: "product_name",
         slots: { customRender: "product_name" },
      },
      {
        title: "产品库分类",
        dataIndex: "name",
        key: "name",
        width:'15%',
        customRender:({record})=>{
            return record.category.name || '未分类'
        } 
      },
      {
        title: "价格/元",
        dataIndex: "product_price",
        key: "product_price",
         width:'12%',
      },
      // {
      //   title: "状态",
      //   dataIndex: "goods",
      //   key: "goods",
      //    width:'12%',
      //    customRender:({record})=>{
      //       return record.goods&&record.goods.is_on_sale==1 ? '已上架云店':'未上架云店'
      //   } 
      // },
  
      {
        title: "操作",
        key: "action",
         width:120,
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    const momentTime = inject("momentTime");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const recovery = (e,type) => {
      $Modal.confirm({
        centered:true,
        content: `您确定要将该商品${type=='del'?'移入回收站？请确认其他应用已下架':'从回收站还原'}`,
        onOk:async () => {
          let res = await createProductRecovery({id:e.id}).then(res => res.data);
          if (iscode(res,true)) {
            initData(search.value);
            $Modal.destroyAll()
          }
        }
      })
    };
    const del=(e)=>{
      $Modal.confirm({
        centered:true,
        content: `您确定要将该商品删除后无法还原`,
        onOk:async () => {
          let res = await deleteProduct(e.id).then(res => res.data);
          if (iscode(res)) {
            initData(search.value);
            $Modal.destroyAll()
          }
        }
      })
    }
    // tabs 点击
    const active=ref(1)
    const callback = (e) => {
      active.value=e
      reset()
      initData(search.value);
    };
    const form=ref()
    const reset=()=>{
     search.value ={ ...defSearch };
    }
    const initData = async (values) => {
      state.listLoading = true;
      state.total= 0;
      data.value = [];
      try {
         let res
         if(active.value==1){
         res = await getProduct(values).then((res) => res.data);
         }else{
         res = await getRecoveryList(values).then((res) => res.data);
         }
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };

    // 导入商品
    const importVisible = ref(false);
    const exportAgent = () => {
      importVisible.value = true;
    };
    //下载失败文件
    const downError = () => {
      window.open(state.importSuccessData.fail_file);
    };
    const exportTemplate = async function () {
      const hide = message.loading("正在加载中...", 0);
      let result = await downloadmanagenmentModel()
        .then((res) => res.data)
        .catch((error) => error);
      window.open(result.data.action);
      setTimeout(hide);
    };
    // 控制
    const handleChange = (e) => {
      state.uploadStatus = "";
      state.hideTime = state.hideTime ? state.hideTime : message.loading("导入中...");

      const status = e.file.status;
      if (status === "done") {
        if (e.file.response.code == 0) {
          // message.success('导入成功')
          importVisible.value = false;
          state.importSuccess = true;
          state.importSuccessData = e.file.response.data;
          setTimeout(state.hideTime);
          initData(search.value);
          return false;
        } else {
          importVisible.value = false;
          setTimeout(state.hideTime);
          $Modal.error({
            title: "导入失败",
            content: e.file.response.msg,
            okText: "确定",
          });
          return false;
        }
      } else if (status === "error") {
        importVisible.value = false;
        setTimeout(state.hideTime);
        $Modal.error({
          title: "导入失败",
          // content:'文件太大',
          okText: "确定",
        });
        return false;
      }
    };

    // 导出产品
    const exportProduct = async () => {
      let res = await exportProductList({ ...search.value, excel: 1 }).then((res) => res.data);
      if (iscode(res, true)) {
        window.open(res.data.file_url);
      }
    };
    onMounted(() => {
      initData(search.value);
    });
    return {
      ...toRefs(state),
      getToken,
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      momentTime,
      recovery,
      callback,
      active,
      reset,
      form,
      del,
      exportProduct,
      importVisible,
      exportAgent,
      downError,
      exportTemplate,
      handleChange,
    };
  },
};
</script>